import { PasswordResetPage } from './password_reset'
export { LandingPage } from './landing'

export const Page = {
    PasswordReset: PasswordResetPage,
}
